// extracted by mini-css-extract-plugin
export default {"titleimage":"Services_titleimage__HXivc","main":"Services_main__TAGwV"};